import { host } from "project-config/utils/env";

export enum FoxMediaLink {
  Linkedin = 6,
  Instagram,
  Facebook,
  X,
  Youtube,
}

export enum BridgeBusiness {
  Linkedin = "Linkedin",
  Instagram = "Instagram",
  Facebook = "Facebook",
  X = "X",
  YouTube = "YouTube",
}

const BUSINESS_MAP: { [key in FoxMediaLink]?: BridgeBusiness } = {
  [FoxMediaLink.Linkedin]: BridgeBusiness.Linkedin,
  [FoxMediaLink.Instagram]: BridgeBusiness.Instagram,
  [FoxMediaLink.Facebook]: BridgeBusiness.Facebook,
  [FoxMediaLink.X]: BridgeBusiness.X,
  [FoxMediaLink.Youtube]: BridgeBusiness.YouTube,
};

const getRedirectUri = (businessType: BridgeBusiness): string => {
  if (typeof window === "undefined") return "";
  if (businessType === BridgeBusiness.YouTube) {
    return encodeURIComponent(`${host}/sso/passport?business=google`);
  }
  if (
    [BridgeBusiness.Facebook, BridgeBusiness.Instagram].includes(businessType)
  ) {
    return encodeURIComponent(`${host}/sso/passport`);
  }
  return encodeURIComponent(
    `${host}/sso/passport?business=${businessType}&from=web`
  );
};

export const getJumpLink = (type: FoxMediaLink): string => {
  const businessType = BUSINESS_MAP[type];
  if (!businessType) return "";

  const redirectUri = getRedirectUri(businessType);
  switch (type) {
    case FoxMediaLink.Linkedin:
      return `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=86k48hpg2bt826&redirect_uri=${redirectUri}&scope=openid%20profile%20email&state=foobar`;
    case FoxMediaLink.X:
      return `https://x.com/i/oauth2/authorize?response_type=code&client_id=SHc4RTZ1VXMycFU5ZGNzejhiZzk6MTpjaQ&redirect_uri=${redirectUri}&scope=tweet.read%20users.read%20follows.read%20follows.write&state=state&code_challenge=JMOTA48yPdXdwvacZnhAQMGz7a5g145uvq9pcf37nK8&code_challenge_method=S256`;
    case FoxMediaLink.Youtube:
      return ` https://accounts.google.com/o/oauth2/v2/auth?response_type=code&client_id=368748365248-qfmrg4eeh11uvef090ivvddpofcp1q47.apps.googleusercontent.com&redirect_uri=${redirectUri}&scope=openid%20profile%20email&access_type=offline&prompt=select_account%20consent&state=${encodeURIComponent(
        `business=${BridgeBusiness.YouTube}&from=web`
      )}`;
    case FoxMediaLink.Facebook:
      return `https://www.facebook.com/v24.0/dialog/oauth?response_type=code&client_id=1282969676552349&redirect_uri=${redirectUri}&scope=public_profile%2Cemail&state=${encodeURIComponent(
        `business=${BridgeBusiness.Facebook}&from=web`
      )}`;
    case FoxMediaLink.Instagram:
      return `https://www.instagram.com/oauth/authorize?client_id=1471917237741200&redirect_uri=${redirectUri}&response_type=code&scope=instagram_business_basic&state=${encodeURIComponent(
        `business=${BridgeBusiness.Instagram}&from=web`
      )}`;
    default:
      return "";
  }
};
